
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M11.1 6.59994L13.4175 4.28242C14.2599 3.46024 15.3904 3 16.5675 3C17.7447 3 18.8751 3.46024 19.7176 4.28242V4.28242C20.5397 5.12483 21 6.25532 21 7.43245C21 8.60959 20.5397 9.74007 19.7176 10.5825L17.4 12.9"></path><path d="M12.9 17.4L10.5825 19.7176C9.74007 20.5397 8.60959 21 7.43245 21C6.25532 21 5.12483 20.5397 4.28242 19.7176V19.7176C3.46024 18.8751 3 17.7447 3 16.5675C3 15.3904 3.46024 14.2599 4.28242 13.4175L6.59994 11.1"></path><path d="M8.3999 15.6L15.6 8.39996"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiLink",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
